(function() {
    'use strict';
    Odigeo.UIElements.collapsive = {};
    Odigeo.UIElements.collapsive.enhance = function(wrapper, newOptions) {
        var $wrapper = (wrapper instanceof $) ? wrapper : $(wrapper);
        var options = {
            expandProperty: 'padding-top',
            expandPanelDuration: 500,
            collapsePanelDuration: 500,
            extraHeight: 0,
            initiallyExpanded: false,
            googleAnalyticsOnOpen: {
                type: '',
                data: {
                    page: '',
                    action: '',
                    label: '',
                },
            },
            googleAnalyticsOnClose: {
                type: '',
                data: {
                    page: '',
                    action: '',
                    label: '',
                },
            },
            googleAnalyticsOnOpenAutomatic: {
                type: ' ',
                data: {
                    page: '',
                    action: '',
                    label: '',
                },
            },
            triggerLauncher: 'collapsive-ui',
            triggerEvents: false,
        };
        var _expandPanel;
        var _collapsePanel;
        var _trackCollapsive;
        var _togglePanel;
        var _togglePanelByParameter;
        var _refresh;

        if ($wrapper.length === 0) {
            return false;
        }

        if ($wrapper.attr('data-skip-enhance') === 'true') {
            return $wrapper;
        }

        $wrapper.addClass('odf-hidden');

        $wrapper.attr({'data-skip-enhance': true});
        options = Odigeo._.extend(options, newOptions);

        _trackCollapsive = function(googleAnalytics, event, hasToTrack) {
            if (options.triggerEvents) {
                Odigeo.trigger(options.triggerLauncher + ':' + event);
            }
            if (googleAnalytics.type !== '' && Odigeo._.isUndefined(hasToTrack)) {
                Odigeo.trigger('analytics:tracking', googleAnalytics);
            }
        };

        _togglePanel = function(event, opt) {
            var isOpenedAutomatic = false;
            var hasToTrack;
            if (Odigeo._.isObject(opt)) {
                isOpenedAutomatic = !!opt.isOpenedAutomatic;
                hasToTrack = opt.hasToTrack;
            }
            if (isOpenedAutomatic || !$wrapper.hasClass('expanded')) {
                _expandPanel(isOpenedAutomatic, hasToTrack);
            } else {
                _collapsePanel();
            }
        };

        _togglePanelByParameter = function(event, isDisplayed) {
            if (isDisplayed) {
                _expandPanel();
            } else {
                _collapsePanel();
            }
        };

        _expandPanel = function(openAutomatic, hasToTrack) {
            $wrapper.removeClass('odf-hidden hidden');
            var height = $wrapper.find('.collapsible_content').height();
            var animateProperty = {};
            var isOpenedAutomatic = Odigeo._.isObject(openAutomatic) ? !!openAutomatic.isOpenedAutomatic : openAutomatic;
            animateProperty[options.expandProperty] = height + options.extraHeight + 'px';
            $wrapper.trigger('onExpand');
            $wrapper.animate(animateProperty, {
                duration: options.expandPanelDuration,
            }).promise().then(function() {
                var result = isOpenedAutomatic ? options.googleAnalyticsOnOpenAutomatic : options.googleAnalyticsOnOpen;
                _trackCollapsive(result, 'panelExpanded', hasToTrack);
                $wrapper.addClass('expanded').trigger('expanded');
            });
        };

        _collapsePanel = function() {
            var animateProperty = {};
            animateProperty[options.expandProperty] = 0;
            $wrapper.removeClass('expanded').trigger('onCollapse');
            $wrapper.animate(animateProperty, {
                duration: options.collapsePanelDuration,
            }).promise().then(function() {
                _trackCollapsive(options.googleAnalyticsOnClose, 'panelCollapsed');
                $wrapper.addClass('odf-hidden hidden').trigger('collapsed');
            });
        };

        _refresh = function() {
            var height = $wrapper.find('.collapsible_content').height();
            $wrapper.css('padding-top', height + options.extraHeight + 'px');
        };


        var container = $('<div>', {'class': 'od-collapsible-expandable'})
            .append($('<div>', {'class': 'od-collapsible-section'})
                .append($('<div>', {'class': 'od-collapsible-content collapsible_content'})));

        $wrapper.addClass('od-collapsible').wrapInner(container);
        $wrapper.on('collapsePanel', _collapsePanel).on('expandPanel', _expandPanel).on('togglePanel', _togglePanel)
            .on('refresh', _refresh).on('togglePanelByParameter', _togglePanelByParameter);

        // To expand without doing the animation
        if (options.initiallyExpanded) {
            $wrapper.removeClass('odf-hidden');
            var height = $wrapper.find('.collapsible_content').height();
            $wrapper.css('padding-top', height + options.extraHeight + 'px').addClass('expanded');
        }

        return $wrapper;
    };
})();
